import Helpers from '@helpers';

const hideModal = () => {
    // hide overlay
    $('.modal-overlay').hide();

    // hide modal
    $('.modal').fadeOut();

    // remove blur
    $('#site-container').removeClass('blur');

    // reset body
    $('body').css('overflow', 'auto');

    resetGalleryModal();
    resetMobileModal();
};

const showModal = () => {
    $('.modal-overlay').show();
    $('#site-container').addClass('blur');
    $('body').css('overflow', 'hidden');
};

const resetGalleryModal = () => {
    $('.soheil-gallery-wrapper').off('click');
    $('.soheil-gallery-wrapper').hide();
    $('.soheil-gallery-image').attr('src', '');
    $('.soheil-gallery-loading').hide();
    $(document).off('keydown');
};

const resetMobileModal = () => {
    $('#mobile-modal\\:sending-code').show();
    $('#mobile-modal\\:code-sent').hide();
    $('#mobile-modal\\:sending-error').hide();
    $('#mobile-modal\\:code').val('');
    $('#mobile-modal\\:error').hide();
};

const ModalHelper = {
    showModal,
    hideModal
};

export default ModalHelper;
